export default __webpack_public_path__ + "static/media/monoful-brand-white.6b34d92e.svg";